<template>
  <TabbedPortletOpportunity class="sticky-top--off OpportunitySelectView">

    <TabbedPortletHead :showToolbar="false" :isStickyTop="false">
      <div class="container-fluid mt-3">
        <SearchForm
          ref="searchForm"
          :formats="formats"
          :brands="brands"
          :brandSelected="brandSelected"
          :themes="themes"
          @onSearch="search"
          @onReset="reset"
          :isSearching="isSearching"
          :isLoading="isLoading"
          :defaultParams="defaultParams" />
      </div>
    </TabbedPortletHead>

    <TabbedPortletBody>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6 search-drag-drop col-12">
            <div class="position-relative column">
              <div class="font-weight-normal bg-info text-white px-3 py-0 column--result">
                Results:&nbsp;
                <span v-if="!isSearching">{{ total }}</span>
                <font-awesome-icon
                  v-else
                  class="text-white"
                  :icon="['fas', 'spinner']"
                  spin />
              </div>
              <div class="toolbar-actions">
                <a
                  class="btn btn-transparent btn-elevate-hover btn-sm btn-icon"
                  :class="{ 'disabled': isLoading }"
                  href=""
                  :disabled="isLoading"
                  @click.prevent="toggleList1">
                  <font-awesome-icon :icon="['fas', 'compress-arrows-alt']" v-if="!collapseAllList1" />
                  <font-awesome-icon :icon="['fas', 'expand-arrows-alt']" v-if="collapseAllList1" />
                </a>
              </div>

              <div class="bg-light DraggableBox" v-if="myArray1.length === 0 && !isDragging">
                <AlertMessage>
                  <svg class="svg-icon dragAndDropSvgIconSize kt-label-font-color-1" viewBox="0 0 20 20" :icon="['fas', 'search']" size="3x" v-if="!isSearching">
                        <path fill="none" d="M19.129,18.164l-4.518-4.52c1.152-1.373,1.852-3.143,1.852-5.077c0-4.361-3.535-7.896-7.896-7.896
                          c-4.361,0-7.896,3.535-7.896,7.896s3.535,7.896,7.896,7.896c1.934,0,3.705-0.698,5.078-1.853l4.52,4.519
                          c0.266,0.268,0.699,0.268,0.965,0C19.396,18.863,19.396,18.431,19.129,18.164z M8.567,15.028c-3.568,0-6.461-2.893-6.461-6.461
                          s2.893-6.461,6.461-6.461c3.568,0,6.46,2.893,6.46,6.461S12.135,15.028,8.567,15.028z"></path>
                  </svg>
                  <font-awesome-icon
                    class="kt-label-font-color-1"
                    :icon="['fas', 'spinner']"
                    size="3x"
                    spin
                    v-if="isSearching" />
                  <h3 class="kt-callout__title kt-label-font-color-1 mt-3" v-if="isSearching">Searching...</h3>
                  <h3 class="kt-callout__title kt-label-font-color-1 mt-3" v-if="!isSearching && !isNotFound">Use the filters to see results...</h3>
                  <h3 class="kt-callout__title kt-label-font-color-1 mt-3" v-if="!isSearching && isNotFound">Sorry, there are no results for your search.</h3>
                  <p class="kt-callout__desc"></p>
                </AlertMessage>
              </div>
              <Draggable
                v-else
                class="bg-light DraggableBox"
                v-model="myArray1"
                :disabled="isLoading"
                :move="checkMove"
                @start="isDragging=true"
                @end="checkEnd"
                v-bind="dragOptions"
                tag="div">
                <ResultsBox
                  v-for="element in myArray1"
                  :key="element.id"
                  :data="element"
                  :isCollapsed="collapseAllList1" />
                <div class="text-center mt-3" slot="footer" key="footer">
                  <button
                    class="btn btn-wide btn-info btn-sm"
                    @click.prevent="loadMore"
                    :disabled="isSearching"
                    v-if="!isComplete">
                    <span v-if="!isSearching">Load more</span>
                    <font-awesome-icon v-else class="text-white" :icon="['fas', 'spinner']" spin />
                  </button>
                </div>
              </Draggable>
            </div>

          </div>

          <div class="col-md-6 search-drag-drop col-12">
            <div class="position-relative column">
              <div class="font-weight-normal bg-danger text-white px-3 py-0 column--result">
                Selected: {{ myArray2.length }}
              </div>
              <div class="toolbar-actions">
                <a
                  class="btn btn-transparent btn-elevate-hover btn-sm btn-icon"
                  :class="{ 'disabled': isLoading }"
                  href=""
                  :disabled="isLoading"
                  @click.prevent="toggleList2">
                  <font-awesome-icon :icon="['fas', 'compress-arrows-alt']" v-if="!collapseAllList2" />
                  <font-awesome-icon :icon="['fas', 'expand-arrows-alt']" v-if="collapseAllList2" />
                </a>
                <a
                  class="btn btn-transparent btn-elevate-hover btn-sm btn-icon"
                  :class="{ 'disabled': isLoading }"
                  href=""
                  :disabled="isLoading"
                  @click.prevent="cleanList2">
                  <font-awesome-icon :icon="['fas', 'trash-alt']" />
                </a>
              </div>

              <div class="bg-light DraggableBox" v-if="myArray2.length === 0 && !isDragging">
                <AlertMessage>
                  <font-awesome-icon class="kt-label-font-color-1" :icon="['fas', 'arrow-alt-circle-down']" size="3x" />
                  <h3 class="kt-callout__title kt-label-font-color-1 mt-3">Drag and drop your selection here</h3>
                  <p class="kt-callout__desc"></p>
                </AlertMessage>
              </div>
              <Draggable
                v-else
                class="bg-light DraggableBox"
                v-model="myArray2"
                :disabled="isLoading"
                @start="isDragging=true"
                @end="checkEnd"
                v-bind="dragOptions"
                tag="div">
                <ResultsBox
                  v-for="(element, index) in myArray2"
                  :key="element.id"
                  :data="element"
                  :isDropped="true"
                  :order="index + 1"
                  :isCollapsed="collapseAllList2" />
              </Draggable>
            </div>

          </div>
        </div>
      </div>
    </TabbedPortletBody>

    <TabbedPortletFoot>
      <template v-slot:rightButtons>
        <BaseButton
          class="btn-outline-hover-info btn-elevate btn-wide text-info mr-1"
          @click="prevStep()"
          :disabled="currentStep <= minSteps || isLoading"
          v-if="!(currentStep <= minSteps)">
          <div class="d-flex align-content-center">
            <font-awesome-icon :icon="['fas', 'chevron-left']" />
            <span class="ml-2 text-footer-button">Prev</span>
          </div>
        </BaseButton>
        <BaseButton
          class="btn-outline-hover-info btn-elevate btn-wide text-info"
          @click="nextStep()"
          :disabled="(currentStep >= maxSteps || !(myArray2.length > 0)) || isLoading"
          v-if="!(currentStep >= maxSteps)">
          <div class="d-flex align-content-center">
            <span class="mr-2 text-footer-button">Next</span>
            <font-awesome-icon :icon="['fas', 'chevron-right']" v-if="!isLoading" />
            <font-awesome-icon :icon="['fas', 'spinner']" spin v-if="isLoading" />
          </div>
        </BaseButton>
      </template>
      <!-- <template v-slot:rightButtons>
        <BaseButton class="btn-wide btn-danger" @click="save()" :disabled="!(myArray2.length > 0)">
          <div class="d-flex align-content-center">
            <span class="kt-hidden-mobile text-uppercase mr-2">Save</span>
            <font-awesome-icon :icon="['fas', 'check']" />
          </div>
        </BaseButton>
      </template> -->
    </TabbedPortletFoot>

  </TabbedPortletOpportunity>
</template>

<script>
import { mapGetters } from 'vuex'
import Draggable from 'vuedraggable'
import flatten from 'lodash/flatten'

import TabbedPortletOpportunity from '@/components/_shared/tabbed-portlet-opportunity/TabbedPortletOpportunity.vue'
import TabbedPortletHead from '@/components/_shared/tabbed-portlet/TabbedPortletHead.vue'
import TabbedPortletBody from '@/components/_shared/tabbed-portlet/TabbedPortletBody.vue'
import TabbedPortletFoot from '@/components/_shared/tabbed-portlet/TabbedPortletFoot.vue'

import SearchForm from '@/components/opportunity-select/SearchForm.vue'
import ResultsBox from '@/components/opportunity-select/ResultsBox.vue'
import AlertMessage from '@/components/opportunity-select/AlertMessage.vue'

import WizardConfig from '@/components/_shared/wizard/config'

export default {
  name: 'OpportunitySelect',
  inject: ['$v'],
  components: {
    Draggable,
    TabbedPortletOpportunity,
    TabbedPortletHead,
    TabbedPortletBody,
    TabbedPortletFoot,
    SearchForm,
    ResultsBox,
    AlertMessage
  },
  data () {
    return {
      collapseAllList1: false,
      collapseAllList2: false,
      currentStep: 2,
      minSteps: WizardConfig.minSteps,
      maxSteps: WizardConfig.maxSteps,
      isDragging: false,
      total: 0,
      myArray1: [],
      myArray2: [],
      searchParams: null,
      isSearching: false,
      isNotFound: false,
      isComplete: false,
      isLoading: false,
      brandSelected: '',
      defaultParams: null,
      privateIdCached: ''
    }
  },
  created () {
    const id = localStorage.getItem('editOpportunity/id')
    if (id) {
      this.privateIdCached = id
    }

    this._restoreNewOpportunityKeysOnLocalStorage()
    const selection = this.$v.newOpportunity.$model.opportunitySelection
    if (selection) {
      this.myArray2 = selection
    }
    this.save(false)
    const brandSelectedFromOpportunityDetailsTab = this.$v.newOpportunity.opportunityDetailsTab.brandId.$model
    if (brandSelectedFromOpportunityDetailsTab) {
      this.brandSelected = brandSelectedFromOpportunityDetailsTab
    }
  },
  computed: {
    ...mapGetters({
      'opportunityDetails': 'opportunity/opportunityDetails',
      'stepSelect': 'opportunity/stepSelect',
      'formatTypes': 'opportunity/formatTypes'
    }),
    dragOptions () {
      return {
        animation: 300,
        group: 'quotations',
        disabled: false,
        ghostClass: 'ghost'
      }
    },
    formats () {
      return this.formatTypes.slice(0, 2)
    },
    brands () {
      if (this.stepSelect) {
        return this.stepSelect.brands
      }
      return []
    },
    themes () {
      if (this.stepSelect) {
        return this.stepSelect.themes
      }
      return []
    }
  },
  methods: {
    cleanList2 () {
      this.myArray1 = []
      this.myArray2 = []
      this.resetSelectedList()
    },
    toggleList1 () {
      this.collapseAllList1 = !this.collapseAllList1
    },
    toggleList2 () {
      this.collapseAllList2 = !this.collapseAllList2
    },
    _goToRoute (stepNumber) {
      const stepSelected = WizardConfig.stepValues.filter(s => s.number === stepNumber).shift()
      const params = {
        privateId: this.$route.params.privateId,
        step: stepNumber
      }
      this.$router.push({ name: stepSelected.url, params })
    },
    prevStep () {
      this.currentStep = this.currentStep - 1
      this._goToRoute(this.currentStep)
    },
    verifyListById (formatList) {
      const res = formatList.filter(f => f.isADay === undefined)
      return res.length > 0
    },
    checkMove (evt, originalEvent) {
      const FULL_ITINERARY = this.formats[0].value
      const DAY_BY_DAY = this.formats[1].value
      if (this.searchParams.format === FULL_ITINERARY && this.myArray2.length >= 1) {
        return false
      }
      if (this.searchParams.format === DAY_BY_DAY && this.verifyListById(this.myArray2)) {
        this.myArray2 = []
        this.resetSelectedList()
      }
    },
    checkEnd () {
      this.isDragging = false
      this.save(false)
    },
    nextStep () {
      // TODO: Validation para enviar la oportunidad
      const FULL_ITINERARY = this.formats[0].value
      const DAY_BY_DAY = this.formats[1].value

      const searchparams = this.searchparams
      const newOpportunity = this.$v.newOpportunity.$model

      let opportunitySelection = null
      let id = null
      let days = []
      let payload = null

      this.isLoading = true

      if (searchparams && searchparams.format === FULL_ITINERARY) {
        id = newOpportunity.opportunitySelection.slice(0, 1).shift().id
      } else if (searchparams && searchparams.format === DAY_BY_DAY) {
        days = newOpportunity.opportunitySelection.map(i => ({ id: i.id }))
      } else {
        this.isLoading = false
        return false
      }

      opportunitySelection = { id, days }

      payload = {
        details: newOpportunity.opportunityDetailsTab,
        client: newOpportunity.clientInformationTab,
        request: newOpportunity.quoteRequestTab,
        selection: opportunitySelection
      }

      const payloadFormatted = {
        'id': null,
        'reference_number': payload.details.referenceNumber,
        'opportunity_name': payload.details.opportunityName,
        'departure_date': payload.details.departureDate ? payload.details.departureDate : null,
        'id_owner': payload.details.ownerId,
        'properties_opportunity': {
          'id': null,
          'id_brand': Number(payload.details.brandId),
          'id_opportunity_export_type': Number(payload.details.typeId)
        },
        'selling_regions': [{ id: Number(payload.details.regionId), order: 0 }],
        'client_details': {
          'id': null,
          'phone_number': payload.client.phoneNumber,
          'account_email': payload.client.email,
          'account_address': payload.client.address,
          'contact_name': payload.client.contactName,
          'account_name': payload.client.accountName,
          'properties_client': {
            'id': null,
            'id_type_client': Number(payload.client.typeId)
          }
        },
        'request_form': {
          'id': null,
          'foc_places': payload.request.focPlaces,
          'quote_deadline': payload.request.quoteDeadline,
          'budget': payload.request.budget ? payload.request.budget : '',
          'percentage_commission': Number(payload.request.commission),
          'airport_arrive': payload.request.arrivalAirportPort,
          'airport_departure': payload.request.departureAirportPort,
          'price_break': payload.request.priceBreak,
          'hotel_standard': Number(payload.request.hotelStandard),
          'additional_information': payload.request.additionalInformation,
          'difficult_dates_checked': Number(payload.request.difficultDatesChecked),
          'prebookings_required': Number(payload.request.prebookingsRequired),
          'flourishes_local_treats': Number(payload.request.flourishesLocalTreats),
          'gratuities_for_td_driver': Number(payload.request.gratuitiesForTdDriver),
          'td_offer_optionals': Number(payload.request.tdOfferOptionals),
          'repeat_guest_gift': Number(payload.request.repeatGuestGift),
          'including_local_guides': Number(payload.request.includingLocalGuides),
          'birthday_allowance': Number(payload.request.birthdayAllowance),
          'group_photo': Number(payload.request.groupPhoto),
          'properties_request_form': {
            'id': null,
            'id_supplier': Number(payload.request.supplierId),
            'id_stage_supplier': Number(payload.request.stageId),
            'id_guests': Number(payload.request.guests),
            'id_additional_doc': 0
          }
        },
        'itineraries': [ payload.selection ]
      }

      this.$store
        .dispatch('opportunity/saveNewOpportunity', payloadFormatted)
        .then((response) => {
          if (response && response.status && response.data) {
            this.save(false)
            const privateId = response.data.uuidOpportunity
            this.$router.push({ name: 'opportunity-edit', params: { privateId } })
            this.isLoading = false
            localStorage.setItem('editOpportunity/id', '') // Cleaning privateIdCached
            this.$notification.success(response.message)
          } else {
            this.isLoading = false
            this.isSearching = false
            this.isNotFound = true
            this.$notification.error(response.message)
          }
        })
        .catch(error => {
          this.isLoading = false
          this.isSearching = false
          this.isNotFound = true
          if (error.response && error.response.data && error.response.data.message) {
            this.$notification.error(error.response.data.message)
          } else if (error.response && error.response && error.response.message) {
            this.$notification.error(error.response.message)
          } else {
            this.$notification.error(error)
          }
        })
    },
    reset () {
      this.myArray1 = []
      if (this.privateIdCached) {
        localStorage.setItem('editOpportunity/id', '') // Cleaning privateIdCached
      } else {
        this.myArray2 = []
        this.resetSelectedList()
      }
      this.isLoading = false
    },
    _restoreNewOpportunityKeysOnLocalStorage () {
      const uuid = this.$route.params.privateId
      const keySearch = `newopportunity/search/${uuid}`
      if (uuid) {
        const searchParams = JSON.parse(localStorage.getItem(keySearch))
        this.defaultParams = searchParams
        this.searchparams = searchParams
      }
    },
    _saveSearchParamsOnLocalStorage (data) {
      const payload = Object.assign({}, data)
      const uuid = this.$route.params.privateId
      const key = `newopportunity/search/${uuid}`
      if (uuid) {
        localStorage.setItem(key, JSON.stringify(payload))
        this.searchparams = payload
      }
    },
    setInputFocus () {
      this.$nextTick(() => {
        if (this.$refs) {
          this
            .$refs.searchForm
            .$refs.searchInput
            .$refs.baseInputForm
            .focus()
        }
      })
    },
    search (params) {
      const FULL_ITINERARY = this.formats[0].value
      const DAY_BY_DAY = this.formats[1].value

      // Addicional info: id_opportunity_export_type
      const newOpportunity = this.$v.newOpportunity.$model
      const opportunityDetailsType = Number(newOpportunity.opportunityDetailsTab.typeId)
      const opportunityDetailsRegionId = Number(newOpportunity.opportunityDetailsTab.regionId)
      params['id_opportunity_export_type'] = opportunityDetailsType
      params['regionId'] = opportunityDetailsRegionId

      this.isSearching = true
      this.myArray1 = []

      this.$store
        .dispatch('opportunity/searchOpportunity', params)
        .then((response) => {
          const data = response.shift()
          this._saveSearchParamsOnLocalStorage(params)
          if (data.total === 0) {
            this.total = 0
            this.isNotFound = true
            this.isSearching = false
            this.isComplete = false
            this.myArray1 = []
            this.numRows = 0
          } else {
            this.searchParams = params
            this.total = Number(data.total)
            if (this.searchParams.format === FULL_ITINERARY) {
              this.myArray1 = data._items
              this.numRows = data._items.length
            } else if (this.searchParams.format === DAY_BY_DAY) {
              const days = data._items.map(item => {
                return item.days.map(d => {
                  return {
                    itineraryCode: item.code,
                    itineraryTitle: item.title,
                    itineraryBrand: item.brand_name,
                    itineraryTheme: item.theme,
                    isADay: true,
                    ...d
                  }
                })
              })
              const flattenDays = flatten(days)
              this.myArray1 = flattenDays
              this.numRows = this.myArray1.length
            }
            this.isSearching = false
            this.isNotFound = false
            this.isComplete = false
          }
          this.setInputFocus()
        })
        .catch(() => {
          this.isSearching = false
          this.isNotFound = true
          this.numRows = 0
        })
    },
    loadMore () {
      const FULL_ITINERARY = this.formats[0].value
      const DAY_BY_DAY = this.formats[1].value

      this.searchParams.offset = this.numRows
      this.isSearching = true

      this.$store
        .dispatch('opportunity/searchOpportunity', this.searchParams)
        .then((response) => {
          const data = response.shift()
          if (data._items) {
            this.total = Number(data.total)
            if (this.searchParams.format === FULL_ITINERARY) {
              this.myArray1.push(...data._items)
              this.numRows = this.numRows + data._items.length
            } else if (this.searchParams.format === DAY_BY_DAY) {
              const days = data._items.map(item => {
                return item.days.map(d => {
                  return {
                    itineraryCode: item.code,
                    itineraryTitle: item.title,
                    itineraryBrand: item.brand_name,
                    itineraryTheme: item.theme,
                    isADay: true,
                    ...d
                  }
                })
              })
              this.myArray1.push(...flatten(days))
              this.numRows = this.numRows + this.myArray1.length
            }
            this.isSearching = false
            this.isNotFound = false
          } else {
            this.isComplete = true
            this.isSearching = false
            this.isNotFound = false
          }
          // this.setInputFocus()
        })
        .catch(() => {
          this.isSearching = false
          this.isNotFound = true
        })
    },
    _saveOnLocalStorage (data) {
      const payload = Object.assign({}, data)
      const uuid = this.$route.params.privateId
      this.$store.commit('opportunity/SAVE_NEWOPPORTUNITY', { uuid, payload })
    },
    save (showNotification = true) {
      // "touching" all fields to turn them "dirty"
      this.$v.$touch()
      if (this.myArray2.length > 0) {
        this.$v.newOpportunity.opportunitySelection.$model = this.myArray2
      }
      // submit form only when all fields are valid
      if (!this.$v.$invalid) {
        const newOpportunityData = this.$v.newOpportunity.$model
        this._saveOnLocalStorage(newOpportunityData)
        if (showNotification) {
          this.$notification.success('Changes saved successfully!')
        }
      }
    },
    resetSelectedList () {
      this.$v.newOpportunity.opportunitySelection.$model = []
      const newOpportunityData = this.$v.newOpportunity.$model
      this._saveOnLocalStorage(newOpportunityData)
      this.total = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.column {
  height: calc(100vh - 300px);
}
.column--result {
  position: absolute;
  font-weight: 500 !important;
  top: -10px;
  left: -0.5px;
  padding: 1px 10px !important;
  border-radius: 3px;
  z-index: 2;
}
.toolbar-actions {
  position: absolute;
  top: -33px;
  right: -12px;
  z-index: 2;
  padding: 0px 4px;
}
.DraggableBox {
  overflow-y: scroll;
  padding: 15px 10px;
  height: calc(100% - 0px);
  box-shadow: 0 0 2px #ccc;
  z-index: 1;
}
.ghost {
  opacity: 0.7;
}
</style>
